import React from 'react';
import Icon from './Icon';
import { WandSparkles } from 'lucide-react';
import { Button } from '../index';

export interface UpgradeCtaCardProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onUpgrade?: () => void;
  className?: string;
  disabled?: boolean;
}

/**
 * UpgradeCtaCard
 *
 * A reusable, customizable card for upgrade CTAs.
 * Used in project lists, chat, upload, etc.
 */

export const UpgradeCtaCard: React.FC<UpgradeCtaCardProps> = ({
  title = 'Upgrade to unlock more',
  description = 'Unlock unlimited projects and advanced features.',
  buttonText = 'Upgrade',
  onUpgrade,
  className = '',
  disabled = false,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (typeof onUpgrade === 'function') {
      e.preventDefault();
      onUpgrade();
    }
    // If string, let <a> handle navigation
  };
  return (
    <div
      className={`flex flex-col items-center justify-center border border-dashed border-primary-400 rounded-3xl p-6 bg-neutral-100 min-h-[180px] ${className}`}
      data-testid="upgrade-cta-card"
    >
      <div className="flex flex-col items-center gap-1 w-11/12">
        <div className="bg-primary-500 w-7 h-7 rounded-md flex items-center justify-center mb-2">
          <Icon icon={WandSparkles} size={16} stroke="#fff" />
        </div>
        <div className="font-semibold text-primary-900 text-center text-sm p-1">{title}</div>
        <div className="text-xs text-neutral-700 text-center mb-3">{description}</div>
        <Button
          variant="primary"
          className="bg-primary-700 hover:bg-primary-800"
          onClick={onUpgrade}
          disabled={disabled}
          size="sm"
          data-track="upgrade_cta"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

UpgradeCtaCard.displayName = 'UpgradeCtaCard';

export default UpgradeCtaCard;
